// component
import Iconify from '../../components/Iconify';

// ----------------------------------------------------------------------

const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;

const navConfig = [
  {
    title: 'dashboard',
    path: '/dashboard/app',
    icon: getIcon('eva:pie-chart-2-fill'),
  },
  {
        title: 'home',
        path: '/dashboard/home',
        icon: getIcon('eva:book-fill'),
      },
  {
    title: 'about',
    path: '#',
    icon: getIcon('eva:file-text-fill'),
    children: [
      
      {
        title: 'about us',
        path: '/dashboard/about',
        icon: getIcon('eva:book-fill'),
      },
      {
        title: 'history',
        path: '/dashboard/history',
        icon: getIcon('eva:book-fill'),
      },{
        title: 'vision & mission',
        path: '/dashboard/vision-mission',
        icon: getIcon('eva:book-fill'),
      },
      {
        title: 'objective',
        path: '/dashboard/objective',
        icon: getIcon('eva:book-fill'),
      },
    ],
  },
  {
    title: 'team',
    path: '#',
    icon: getIcon('eva:file-text-fill'),
    children: [
      {
        title: 'members',
        path: '/dashboard/members',
        icon: getIcon('eva:people-fill'),
      },
      {
        title: 'president',
        path: '/dashboard/president',
        icon: getIcon('eva:people-fill'),
      },
      {
        title: 'secretary',
        path: '/dashboard/secretary',
        icon: getIcon('eva:people-fill'),
      },
    ],
  },
  {
    title: 'services',
    path: '#',
    icon: getIcon('eva:file-text-fill'),
    children: [
      {
        title: 'what we do',
        path: '/dashboard/whatwedo',
        icon: getIcon('eva:people-fill'),
      },
      {
        title: 'training programs',
        path: '/dashboard/trainingPrograms',
        icon: getIcon('eva:people-fill'),
      },
      {
        title: 'consultancy',
        path: '/dashboard/consultancy',
        icon: getIcon('eva:people-fill'),
      },
      {
        title: 'poster',
        path: '/dashboard/poster',
        icon: getIcon('eva:people-fill'),
      },
      {
        title: 'chronicles',
        path: '/dashboard/chronicles',
        icon: getIcon('eva:people-fill'),
      },
    ],
  },

  {
    title: 'courses',
    path: '#',
    icon: getIcon('eva:file-text-fill'),
    children: [
      {
        title: 'pgdpm',
        path: '/dashboard/pgdpm',
        icon: getIcon('eva:people-fill'),
      },
      {
        title: 'dqm',
        path: '/dashboard/dqm',
        icon: getIcon('eva:people-fill'),
      },
    ],
  },
  {
    title: 'events',
    path: '#',
    icon: getIcon('eva:file-text-fill'),
    children: [
      {
        title: 'productivityconclave',
        path: '/dashboard/productivityconclave',
        icon: getIcon('eva:person-fill'),
      },
      {
        title: 'productivityweekcelebrations',
        path: '/dashboard/productivityweekcelebrations',
        icon: getIcon('eva:person-fill'),
      },
      {
        title: 'safetyconclave',
        path: '/dashboard/safetyconclave',
        icon: getIcon('eva:person-fill'),
      },
      {
        title: 'hrconclave',
        path: '/dashboard/hrconclave',
        icon: getIcon('eva:person-fill'),
      },
      {
        title: 'skillconclave',
        path: '/dashboard/skillconclave',
        icon: getIcon('eva:person-fill'),
      },
      {
        title: 'qualityconclave',
        path: '/dashboard/qualityconclave',
        icon: getIcon('eva:person-fill'),
      },
      {
        title: 'ortherconclave',
        path: '/dashboard/ortherconclave',
        icon: getIcon('eva:person-fill'),
      },
    ],
  },
  {
    title: 'gallery',
    path: '/dashboard/gallery',
    icon: getIcon('eva:people-fill'),
  },
  {
    title: 'members admin',
    path: '/dashboard/members-admin',
    icon: getIcon('eva:people-fill'),
  },
  {
    title: 'facilities',
    path: '/dashboard/facilities',
    icon: getIcon('eva:people-fill'),
  },
  {
    title: 'rental details',
    path: '/dashboard/rental-details',
    icon: getIcon('eva:people-fill'),
  },
  {
    title: 'contact',
    path: '/dashboard/contact',
    icon: getIcon('eva:email-fill'),
  },

  {
    title: 'profile',
    path: '/dashboard/profile',
    icon: getIcon('eva:person-fill'),
  },
];

export default navConfig;
